import React from "react";
import { IGroup } from "../types";

export const GroupContext = React.createContext<IGroup>({ id: -1, title: "" });
